export const delayAdvanceValues = () => {
  const values = [];
  for (let i = -120; i <= 120; i++) {
    values.push({
      value: i,
      name: i
    });
  }
  return values;
};

export const delayAdvanceOptions = delayAdvanceValues();